import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "userSlice",
  initialState: {
    enterDateModel: {
      userId: null,
      isStartDate: true,
      personelName: "",
      departmentName: "",
    },
    selectedUserId: null,
  },
  reducers: {
    setEnterDateModel(state, action) {
      state.enterDateModel.userId = action.payload.userId;
      state.enterDateModel.isStartDate = action.payload.isStartDate;
      state.enterDateModel.personelName = action.payload.personelName || "";
      state.enterDateModel.departmentName = action.payload.departmentName || "";
    },
    setSelectedId(state, action) {
      state.selectedUserId = action.payload;
    },
  },
});

export const { setEnterDateModel, setSelectedId } = userSlice.actions;

export const userReducer = userSlice.reducer;
